module.exports = __webpack_public_path__ + "img/logo.76942d07.png";